module.exports = __webpack_public_path__ + "media/reportAssets/PerceptionsOfDesign-4d10d973.jpg";